module.exports = __webpack_public_path__ + "img/mh.319c468d.svg";